
module.exports = require('./lib');




//////////////////
// WEBPACK FOOTER
// ./modules/socketapi/~/socket.io-stream/index.js
// module id = 785
// module chunks = 0